import React from "react";
import type { KgHeaderActionId } from "../../../services/kg/kgSectionRegistry";
import { SaveDraftButton } from "../../atoms/SaveDraftButton";
import { ActionsRow, DarkPrimaryActionButton } from "./KgHeaderActionButtons.styles";
import type {
  KgHeaderActionButtonsProps,
  KgHeaderActionHandlers,
} from "./KgHeaderActionButtons.types";

const handlerForId = (
  id: KgHeaderActionId,
  props: KgHeaderActionHandlers,
): (() => void) | undefined => {
  if (id === "saveDraft") return props.onSaveDraft;
  if (id === "saveVerify") return props.onSaveAndVerify;
  return undefined;
};

const loadingForId = (
  id: KgHeaderActionId,
  props: KgHeaderActionHandlers,
): boolean => {
  if (id === "saveDraft") return Boolean(props.isSaveDraftLoading);
  if (id === "saveVerify") return Boolean(props.isSaveVerifyLoading);
  return false;
};

export const KgHeaderActionButtons: React.FC<KgHeaderActionButtonsProps> = ({
  actions,
  onSaveDraft,
  onSaveAndVerify,
  isSaveDraftLoading = false,
  isSaveVerifyLoading = false,
  className,
}) => {
  const handlers: KgHeaderActionHandlers = {
    onSaveDraft,
    onSaveAndVerify,
    isSaveDraftLoading,
    isSaveVerifyLoading,
  };

  return (
    <ActionsRow className={className} data-testid="kg-header-action-buttons">
      {actions.map((action) => {
        const onClick = handlerForId(action.id, handlers);
        const isLoading = loadingForId(action.id, handlers);

        if (action.variant === "outline-primary") {
          return (
            <SaveDraftButton
              key={action.id}
              headerMinWidth
              onClick={onClick}
              disabled={!onClick || isLoading}
              data-testid={`kg-header-action-${action.id}`}
            >
              {action.label}
            </SaveDraftButton>
          );
        }

        return (
          <DarkPrimaryActionButton
            key={action.id}
            type="button"
            size="md"
            variant="primary-dark"
            onClick={onClick}
            disabled={!onClick || isLoading}
            data-testid={`kg-header-action-${action.id}`}
          >
            {action.label}
          </DarkPrimaryActionButton>
        );
      })}
    </ActionsRow>
  );
};

export default KgHeaderActionButtons;
